<template>
    <div>
      <div class="col-md-6 mx-auto">

        <div class="row">
        <div class="col-md-12 py-2"><input id="email" type="email" placeholder="Your email address" name="email" class="form-control" v-model="email"></div>
        <div class="col-md-12 py-2">
          <i class="fas fa-spinner fa-spin fa-2x" v-if="loading"></i>
          <button v-else type="submit" class="btn btn-danger btn-block" @click="submitForm">Get started</button>
          </div>
        </div>

      </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      email: '',
      error_message: '',
      loading: false,
    };
  },

  created() {
    
  },

  methods: {

      submitForm() {

          this.error_message = '';

          if (this.email=='') { this.sweetfire('Please enter your email address')}

          else {

          this.loading = true;

          axios
          .post('/register-email', {email: this.email})
          .then((response) => {
            
            if (response.data.success) {
              window.open(response.data.url, '_self');
            }

            else {
              this.sweetfire(response.data.message)
              this.loading = false;
            }
          
          });

          }
      
      },


    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};
</script> 

<style scoped>

.form-control, .form-control:focus {
  border-radius: 5px;
  background: #fff;
  color: #121212;
  text-align: center;
  border: none !important;
}
</style>